import { makeAutoObservable } from 'mobx';
import { logger } from '@/utils/logger';
import { STORAGE_KEYS } from '../constants/constants';

class ChatCredentialsStore {
  // 客服聊天凭证信息
  credentials = null;

  constructor() {
    makeAutoObservable(this);
    this.loadCredentials();
  }

  // 获取客服专用的凭证存储 key
  getServiceCredentialsKey() {
    return `${STORAGE_KEYS.CREDENTIALS}_SERVICE`;
  }

  loadCredentials() {
    const credentialsStr = localStorage.getItem(this.getServiceCredentialsKey());

    if (credentialsStr) {
      try {
        this.credentials = JSON.parse(credentialsStr);
      } catch (error) {
        logger.error('解析客服聊天凭证信息失败:', error);
        this.credentials = null;
      }
    }
  }

  // 验证 credentials 是否已正确初始化
  isCredentialsValid() {
    if (!this.credentials) {
      return false;
    }
    const { sdkAppId, userSig, userId } = this.credentials;
    const isValid = !!(sdkAppId && userSig && userId);
    return isValid;
  }

  setCredentials(credentials) {
    this.credentials = credentials;

    // 添加 console.log 打印存储的凭证格式
    console.log('[IFRAME] 存储登录凭证:', {
      sdkAppId: credentials?.sdkAppId,
      userId: credentials?.userId,
      chatUserId: credentials?.chatUserId,
      hasUserSig: !!credentials?.userSig,
      fullCredentials: credentials,
    });

    // 同时保存到 localStorage，持久化存储
    if (credentials) {
      try {
        localStorage.setItem(this.getServiceCredentialsKey(), JSON.stringify(credentials));
        logger.info('[ChatCredentialsStore] 客服登录凭证已保存到 localStorage:', {
          sdkAppId: credentials.sdkAppId,
          userId: credentials.userId,
          hasUserSig: !!credentials.userSig,
        });
      } catch (error) {
        logger.error('[ChatCredentialsStore] 保存客服登录凭证到 localStorage 失败:', error);
      }
    } else {
      // 如果凭证为空，清除 localStorage
      localStorage.removeItem(this.getServiceCredentialsKey());
      logger.info('[ChatCredentialsStore] 客服登录凭证已从 localStorage 清除');
    }
  }

  // 获取存储的凭证
  getCredentials() {
    return this.credentials;
  }

  // 获取虚拟客服用户ID
  getVirtualServiceUserId() {
    return this.credentials?.virtualServiceUser?.id;
  }

  // 从 localStorage 重新加载凭证
  reloadCredentials() {
    this.loadCredentials();
    return this.credentials;
  }

  reset() {
    this.credentials = null;
    // 同时清除 localStorage
    localStorage.removeItem(this.getServiceCredentialsKey());
    logger.info('[ChatCredentialsStore] 客服登录凭证已重置');
  }
}

export const chatCredentialsStore = new ChatCredentialsStore();
